import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSampleOrderProductInfo, getSchoolAddressMagentoApiCall } from '.';
import { SampleOrderProductInfo } from './instructor-sample.interface';
import { RecaptchaAction, getRecaptchaToken } from '../../common/recaptcha';
import { PAYMENT_MESSAGE_ID, updateGlobalMessage } from '../alert/global-message';
import { Message, MessageType } from '../alert/global-message.interface';
import { loadCustomer } from '../customer/customer';
import { MessageTemplateId } from '../../common/constants/api-constants';

/*----- DECLARE THUNKS ------*/

export const getMagentoSchoolAddressThunk = createAsyncThunk('instructorSample/getMagentoSchoolAddress', async (_, thunkAPI) => {
  try {
    await thunkAPI.dispatch(loadCustomer());
    const token = await getRecaptchaToken(RecaptchaAction.sample);

    return await getSchoolAddressMagentoApiCall(token);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const createSampleOrderProductInfo = createAsyncThunk('instructorSample/createSampleOrderProductInfo', async(isbn: string, thunkAPI) =>{
  try{
    const sampleOrderProductInfo: SampleOrderProductInfo = await getSampleOrderProductInfo(isbn);

    return sampleOrderProductInfo;
  } catch(error) {
    const message: Message = {
      message: MessageTemplateId.ORDER_CONFIRMATION_ERROR,
      type: MessageType.primary
    }
    thunkAPI.dispatch(updateGlobalMessage({
      id: PAYMENT_MESSAGE_ID,
      ...message
    }));
    return thunkAPI.rejectWithValue(error);
  }
});
